import history from 'services/history'
import {makeEntityUrl} from 'common/Links'


export default function redirect(to: any) {
	if (typeof to === 'string' || to instanceof String) {
		history.push(to as string)
	}
	else {
		const url = makeEntityUrl(to)
		history.push(url)
	}
}
